module.exports = __webpack_public_path__ + "static/media/ic_marketing_active.6af4e9d9.svg";